<template>
    <el-scrollbar class="training-detail">
        <div class="training-detail-box">
            <div class="training-detail-box_header">
                <div class="header-label">技能考核</div>
            </div>

            <div class="training-detail-box_filter">
                <el-cascader
                    v-model="courseValue"
                    :options="courseOptions"
                    :props="cascProp"
                    @change="handleChapterChange"
                    :show-all-levels="false"
                ></el-cascader>

                <el-button type="primary" @click="$router.back()">返回</el-button>
            </div>

            <el-table
                :data="tableData"
                style="
                    width: 100%;
                    flex: 1;
                    border: 1px solid #f2f4f7;
                    border-radius: 4px;
                "
                size="medium"
                :header-cell-style="{
                    fontWeight: 'normal',
                    color: '#333',
                    background: '#f5f7fa',
                }"
                class="table-content"
                :cell-style="{ fontSize: '12px', color: '#333' }"
            >
                <el-table-column label="内容" prop="project_title"></el-table-column>

                <el-table-column label="操作" width="100" :align="'center'">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleProjectDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- <SkillAssessmentDetailDialog
            :student-id="s_id"
            :project-id="dialogData.id"
            :visible="dialogData.visible"
            :is-operate="false"
            :zhang="dialogData.zhangIndex"
            :jie="dialogData.jieIndex"
            @close="closeDialog"
            @preview="previewSource"
        ></SkillAssessmentDetailDialog> -->

        <div class="preview-box" v-if="previewUrl && !loading">
            <ElImageViewer class="preview-img" :url-list="[previewUrl]" alt="" v-if="['jpg', 'png'].includes(getFileExtensiion)" />

            <i class="el-icon-close" @click="closePreview"></i>
        </div>
    </el-scrollbar>
</template>

<script>
// import SkillAssessmentDetailDialog from "../../qualityCourse/SkillAssessmentDetailDialog.vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
    name: "TrainingDetail",
    data() {
        return {
            tableData: [],
            dialogData: {
                id: undefined,
                visible: false,
                zhangIndex: undefined,
                jieIndex: undefined,
            },
            previewUrl: "", // 预览文件名路径
            s_id: Number(localStorage.getItem("s_id")),
            courseOptions: [],
            courseValue: [],
            cascProp: { label: "name", children: "children", value: "index" },
        };
    },
    created() {
        this.getCourseList();
    },
    components: {
        // SkillAssessmentDetailDialog,
        ElImageViewer,
    },
    computed: {
        // 获得文件扩展名
        getFileExtensiion() {
            const fileExtension = this.previewUrl?.slice(((this.previewUrl.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            return fileExtension;
        },
    },
    methods: {
        // 获取课程列表
        getCourseList() {
            // /admin/cefinoorsu;
            const params = {
                id: Number(this.$route.query.course_id),
            };

            this.$shttp.axiosGetBy(this.$api.courseContent, params, (res) => {
                if (res.code === 200) {
                    const courseContent = res.data.course_content;
                    this.formatterCourseList(courseContent);

                    this.courseOptions = courseContent;
                    this.courseValue = [0, 0];

                    this.getProjectList();
                }
            });
        },

        formatterCourseList(courseList) {
            for (let i = 0; i < courseList.length; i++) {
                const courseItem = courseList[i];

                if (!!courseItem.id) return false;

                courseItem.index = i;

                if (courseItem.children && courseItem.children.length > 0) {
                    if (!this.formatterCourseList(courseItem.children)) {
                        delete courseItem.children;
                    }
                }
            }

            return true;
        },

        getProjectList() {
            if (this.courseValue.length < 2) return;

            const params = {
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
            };

            this.$shttp.axiosGetBy(
                this.$api.evaluation_training_project,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.tableData = res.data.list || [];
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    const errorData = error.response.data;
                    this.$message.error(errorData.msg);
                },
            );
        },

        handleChapterChange(val) {
            this.courseValue = val;
            this.getProjectList();
        },

        handleProjectDetail(row) {
            // this.dialogData.id = row.project_id;
            // this.dialogData.visible = true;
            // this.dialogData.zhangIndex = this.courseValue[0];
            // this.dialogData.jieIndex = this.courseValue[1];
            this.$router.push({
                path: "/qualityCourse/student/dataEvaluationIndex/trainingDetail",
                query: { 
                    s_id: localStorage.getItem("s_id"), 
                    c_id: localStorage.getItem("c_id"),
                    project_id: row.project_id,
                    course_id: this.$route.query.course_id,
                    zhangIndex: this.courseValue[0],
                    jieIndex: this.courseValue[1],
                },
            });
        },

        // 预览文件
        previewSource(url) {
            this.previewUrl = url;
        },

        // 关闭文件预览
        closePreview() {
            this.previewUrl = "";
        },

        // 关闭弹框
        closeDialog() {
            // this.dialogData.id = undefined;
            // this.dialogData.visible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-scrollbar__wrap {
    margin: 0 !important;

    &::-webkit-scrollbar {
        display: none;
    }
}

.training-detail {
    height: 100%;
    height: calc(100vh - 70px);
    box-sizing: border-box;
    padding: 20px;

    .training-detail-box {
        background-color: #ffffff;
        padding: 24px 40px;
        border-radius: 4px;
        box-sizing: border-box;
        min-height: calc(100vh - 152px);

        &_header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 24px;
            margin-bottom: 20px;

            .header-label {
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 800;
                font-size: 24px;
                color: #333333;
            }

            .el-button {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 88px;
                height: 36px;
            }
        }

        &_filter {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .el-button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                height: 36px;
            }

            ::v-deep .el-input__inner {
                background-color: #ffffff !important;
            }
        }

        .pagination {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
        }
    }

    .preview-box {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;
        z-index: 9999;
        background-color: rgba(0, 0, 0, 0.3);

        ::v-deep .el-image-viewer__wrapper {
            .el-image-viewer__mask {
                display: none;
            }

            .el-icon-circle-close {
                display: none;
            }

            .el-image-viewer__canvas img {
                width: 40% !important;
                height: auto !important;
            }
        }

        .el-icon-close {
            position: absolute;
            right: 50px;
            top: 30px;
            font-size: 40px;
            cursor: pointer;
            color: #ffffffda;
            z-index: 9999;
        }
    }

    ::v-deep .el-dialog {
        position: absolute;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 90vh;
        overflow: hidden;

        .el-dialog__header {
            padding: 15px 20px;
        }

        .el-dialog__body {
            padding: 0;
        }
    }
}
</style>
